var map = {
	"./Calculator.png": 569,
	"./CountDownTimer.png": 501,
	"./Portfolio-img.png": 235,
	"./RockpaperscissorGame.png": 440,
	"./Temp-conv.png": 124,
	"./TodoList-Innovixian.png": 963,
	"./TodoList-OctaNet.png": 258,
	"./Weather-Report.png": 990,
	"./amazon-clone.png": 433,
	"./nature-calls-landingPage.png": 723,
	"./tic-tac-toe-game.png": 574,
	"./tribute-page.png": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 261;